import { Asset, Loader, Title } from "@sicredi/react";
import React from "react";

export default function CallbackSuccessPage() {
  return (
    <div
      data-testid="callback-success"
      style={{
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Title as="h1">Sucesso!</Title>
      <Loader show={true} fullScreen />
      <Asset name="product-signed" />
    </div>
  );
}
